import { useQuery } from '@tanstack/react-query';

import { Address } from 'viem';

import { WagmiConfigChain } from '@shared/common/providers/Web3Provider/wagmi';
import { DEFAULT_TARGET_CHAIN } from '@shared/constants';
import { getToken } from '@shared/helpers/web3/getToken';

const useTokenInfo = ({
  tokenAddress,
  walletAddress,
  chainId = DEFAULT_TARGET_CHAIN.id,
  enabled = true,
}: {
  tokenAddress: Address;
  walletAddress?: Address;
  chainId?: WagmiConfigChain['id'];
  enabled?: boolean;
}) => {
  return useQuery({
    queryKey: ['tokenInfo', walletAddress, tokenAddress],
    queryFn: () =>
      getToken({
        tokenAddress,
        walletAddress,
        chainId,
      }),
    enabled: enabled && !!tokenAddress,
  });
};

export default useTokenInfo;
